<template>
    <UModal :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)">
        <UCard>
            <template #header>
                <div class="flex items-center justify-between">
                    <h3 class="text-lg font-semibold">Resend Email</h3>
                    <UButton icon="i-ph-x" variant="ghost" color="gray" @click="$emit('update:modelValue', false)" />
                </div>
            </template>

            <div class="space-y-3">
                <UAlert
                    icon="i-ph-warning-fill"
                    color="amber"
                    variant="soft"
                    :title="`Email was already sent${sharedAtLabel}.`"
                    description="Resending issues a fresh 30-day link and notifies the provider again. Older unexpired links remain valid."
                />
            </div>

            <template #footer>
                <div class="flex gap-3 justify-end">
                    <UButton color="gray" variant="ghost" @click="$emit('update:modelValue', false)">Cancel</UButton>
                    <UButton color="black" :loading="submitting" @click="$emit('submit')">Resend Email</UButton>
                </div>
            </template>
        </UCard>
    </UModal>
</template>

<script setup lang="ts">
import dayjs from 'dayjs'

const props = defineProps<{
    modelValue: boolean
    sharedAt?: string | null
    submitting?: boolean
}>()

defineEmits<{
    (e: 'update:modelValue', value: boolean): void
    (e: 'submit'): void
}>()

const sharedAtLabel = computed(() => props.sharedAt ? ` on ${dayjs(props.sharedAt).format('MMM D, YYYY')}` : '')
</script>
